import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionComponent } from './permission/permission.component';
import { NotificationConfigComponent } from './notification-config/notification-config.component';
import { NotificationLogsComponent } from './notification-logs/notification-logs.component';
import { WhatsappConfigComponent } from './whatsapp-config/whatsapp-config.component';

const routes: Routes = [
    {
        path: "setting", component: DashboardComponent, canActivate: [AuthGuard], children: [
            {
                path: "permissions", component: PermissionComponent, data: { module: "Permisos", accion: "Gestión de Permisos por Roles", type: "roles" }
            },
            {
                path: "notification-config", component: NotificationConfigComponent, data: { module: "Notificaciones", accion: "Configuración de Notificaciones", type: "notifications" }
            },
            {
                path: "notification-logs", component: NotificationLogsComponent, data: { module: "Notificaciones", accion: "Logs de Notificaciones", type: "notifications" }
            },
            {
                path: "whatsapp-config", component: WhatsappConfigComponent, data: { module: "Notificaciones", accion: "Configuración de WhatsApp", type: "notifications" }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SettingRoutingModule { }
